import { cloneComponent, Component, Container } from "@mcleod/components";

interface UndoInfo {
  component: Component;
  parent: Container;
}

export class ActionPasteComponent {
  topLevelParent: Container;
  pasteComponents: Component[];
  parent: Container;
  cutting: boolean;
  undoInfo: UndoInfo[];

  constructor(topLevelParent, pasteComponents, parent, cutting) {
    this.topLevelParent = topLevelParent;
    this.pasteComponents = pasteComponents;
    this.parent = parent;
    this.cutting = cutting;
    this.undoInfo = [];
  }

  execute() {
    for (const comp of this.pasteComponents) {
      this.undoInfo.push({ component: comp, parent: comp.parent });
      if (this.cutting)
        this.parent.add(comp);
      else {
        const copy = cloneComponent(comp, null, null, null, null, (id) => this.calcPastedId(id));
        this.parent.add(copy);
      }
    }
  }

  calcPastedId(id: string): string {
    const compsById = this.topLevelParent.getRecursiveChildrenById();
    let lastDigitIndex = id.length - 1;
    while (id[lastDigitIndex] >= "0" && id[lastDigitIndex] <= "9")
      lastDigitIndex--;
    lastDigitIndex++;
    const suffix = id.substring(lastDigitIndex);
    const prefix = id.substring(0, lastDigitIndex);
    let number = parseInt(suffix);
    if (isNaN(number))
      number = 0;
    for (let i = number + 1; i < 1000; i++)
      if (compsById[suffix + number] == null)
        return prefix + i;
    return null;
  }

  undo() {
    for (const info of this.undoInfo) {
      if (this.cutting)
        info.parent.add(info.component);
      else
        info.component.parent.remove(info.component);
    }
  }

  toString() {
    return "Paste " + this.pasteComponents[0].constructor.name;
  }
}
